import React, { useState } from "react";
import { Globals as OldGlobals } from "../../global/Globals";
import Button from "../../components/Button/Button";
import './ResetPassword.css';
import { useNavigate } from "react-router-dom";
import { fetchEmail } from '../../services/GenericAPI';
import { sendResetRequestLink } from '../../services/api';
import { useLanguage } from "../../context/Languagecontext";

const ResetPassword = ({ renderToast }) => {
    const [email, setEmail] = useState('');
    const [validMail, setValidMail] = useState(true);
    const [errorMessage, setErrorMessage] = useState();
    const { Globals ,languages, setLanguages } = useLanguage();

    const sendResetLink = (emailId) => {
        sendResetRequestLink(emailId).then((response) => {
            response?.data?.status === "OK" ? renderToast("success", Globals.RESET_ACCOUNT_PASSWORD.TOAST_SUCCESS) : renderToast("error", Globals.TOAST_FAILURE)
        }).catch((error) => { renderToast("error", Globals.TOAST_FAILURE) })
    }

    const validateEmail = (e) => {
        setValidMail(true);
        const value = e.target.value
        setEmail(value)
        if (value.length === 0) {
            setErrorMessage(Globals.ERROR_MESSAGES.EMPTY_EMAIL);
            setValidMail(false);
        } else {
            const emailRegex = OldGlobals.REGEX.EMAIL_REGEX;
            const isValidEmail = emailRegex.test(value);
            if (!isValidEmail) {
                setValidMail(false);
                setErrorMessage(Globals.ERROR_MESSAGES.INVALID_EMAIL_FORMAT);
            } else {
                fetchEmail(value).then((response) => {
                    if (response.data.exists) {
                        setValidMail(true)
                    } else {
                        setValidMail(true);
                        setErrorMessage(Globals.ERROR_MESSAGES.EMAIL_NOT_EXIST);
                    }
                }).catch((error) => { setValidMail(true); setErrorMessage(Globals.ERROR_MESSAGES.EMAIL_NOT_EXIST); })
            }
        }

    }

    return (
        <>
            <div id="reset-page" className="reset-page">
                <div id="title" className="reset-page-title">
                    <h3 className="reset-page-title">{Globals.LOGIN.RESET_PASSWORD}</h3>
                </div>
                <div className="reset-email-wrapper">
                    <label id="email-label" className="reset-email-label">{Globals.LOGIN.EMAIL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                    <input id="email-inp" className="email-inp" name="email" value={email} placeholder={Globals.LOGIN.EMAIL_PLACEHOLDER} onChange={validateEmail} onBlur={validateEmail} required></input>
                    {!validMail &&
                        <div>
                            <img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" />
                            <label className='invalidCredential'>
                                {errorMessage}
                            </label>
                        </div>
                    }
                </div>
                <div className="reset-link">
                    <Button title={Globals.LOGIN.RESET_LINK_EMAIL} action={(e) => { sendResetLink(email) }} additionalStyle={validMail ? "reset-btn" : "reset-btn-disabled"} disable={!validMail} />
                </div>
            </div>
        </>
    )

}
export default ResetPassword;
